module.exports = "//docs.gtimg.com/slide/img/slide/application/service/slide-rating-and-improve/view/mobile/start/mobile-blank-search-530529.svg";